import type { ClassSnapshot } from "shared";
import styled from "styled-components";
import { getLocalDate } from "../../../class-list/operators/getLocalDate";
import { getLocalTime } from "../../../class-list/operators/getLocalTime";

const Card = styled.div`
  border: 1px solid ${(props) => props.theme.colors.status.free.text}40;
  border-left: 4px solid ${(props) => props.theme.colors.status.free.text};
  border-radius: ${(props) => props.theme.borderRadius};
  background-color: ${(props) => props.theme.colors.status.free.bg};
  padding: 12px 14px;
`;

const Label = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${(props) => props.theme.colors.status.free.text};
  margin-bottom: 6px;
`;

const ClassInfo = styled.div`
  font-size: 13px;
  color: ${(props) => props.theme.colors.main};
  font-weight: 500;
`;

const Meta = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.secondary};
  margin-top: 2px;
`;

const DetectedAt = styled.div`
  font-size: 11px;
  color: ${(props) => props.theme.colors.secondary};
  opacity: 0.6;
  margin-top: 2px;
`;

interface Props {
  snapshot: ClassSnapshot;
  timezone: string;
}

export const MatchCard = ({ snapshot, timezone }: Props) => {
  const date = getLocalDate(snapshot.starts_at, timezone, false);
  const time = getLocalTime(snapshot.starts_at, timezone);
  const detectedTime = getLocalTime(
    new Date(snapshot.snapshotAt).toISOString(),
    timezone
  );
  const instructorName = snapshot.instructors[0]?.name ?? "Unknown instructor";
  const spotsLeft = snapshot.maxOccupancy - snapshot.occupancy;

  return (
    <Card>
      <Label>● Would have triggered</Label>
      <ClassInfo>
        {date} {time}
        {snapshot.name ? ` · ${snapshot.name}` : ""}
        {" · "}
        {instructorName}
      </ClassInfo>
      <Meta>
        {snapshot.status === "free"
          ? `Free · ${spotsLeft} spot${spotsLeft === 1 ? "" : "s"} available`
          : snapshot.status === "waitlist"
            ? `Waitlist · ${snapshot.waitingCount} waiting`
            : "Full"}
      </Meta>
      <DetectedAt>detected at {detectedTime}</DetectedAt>
    </Card>
  );
};
